import { useNavigate } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { Button, TextInput, StoreSelect } from 'components/common'
import { Dropdown } from 'components/common'
import { PAGE_PURCHASE_TIMER } from 'utils/constants'
import { createPurchaseTimer } from 'utils/api/purchaseTimerApi'
import toast from 'react-hot-toast'
import { PURCHASE_TIMER_FORM_FIELDS } from './utils'

const {
  BARCODE,
  STORE,
  AVAILABLE_TO_PURCHASE_TIMER,
  PURCHASE_START_TIME,
  PURCHASE_END_TIME,
} = PURCHASE_TIMER_FORM_FIELDS

const PurchaseTimerAddForm = () => {
  const navigate = useNavigate()

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm<any>({
    defaultValues: {
      barcode: '',
      store: '',
      availableToPurchaseTimer: true,
      purchaseStartTime: '',
      purchaseEndTime: '',
    },
  })

  const backToPurchaseTimer = () => {
    navigate(PAGE_PURCHASE_TIMER.path)
  }

  const handleCreate = async (data: any) => {
    const toastId = toast.loading('Creating Purchase Timer...')
    try {
      await createPurchaseTimer({
        barcode: data.barcode,
        store: data.store,
        availableToPurchaseTimer: data.availableToPurchaseTimer,
        purchaseStartTime: data.purchaseStartTime,
        purchaseEndTime: data.purchaseEndTime,
      })
      toast.success('Purchase Timer created successfully!', { id: toastId })
      reset()
      backToPurchaseTimer()
    } catch (error: any) {
      const msg = error?.response?.data?.errors?.msg
      toast.error(msg || 'Failed to create Purchase Timer.', { id: toastId })
    }
  }

  return (
    <div className="rounded-lg border bg-white px-5 py-3">
      <div className="mx-auto max-w-5xl">
        <form onSubmit={handleSubmit(handleCreate)}>
          <div className="grid grid-cols-1 gap-x-14 gap-y-3 md:grid-cols-3">
            <TextInput
              register={register}
              name={BARCODE.key}
              label={BARCODE.label}
              required
              error={errors?.[BARCODE.key]?.message as string}
            />

            <StoreSelect
              name={STORE.key}
              label={STORE.label}
              setValue={setValue}
              required
              error={errors?.[STORE.key]?.message as string}
            />

            <Dropdown
              name={AVAILABLE_TO_PURCHASE_TIMER.key}
              label={AVAILABLE_TO_PURCHASE_TIMER.label}
              setValue={setValue}
              defaultValue={true}
              error={
                errors?.[AVAILABLE_TO_PURCHASE_TIMER.key]?.message as string
              }
              options={[
                { label: 'Yes', value: true, disabled: false },
                { label: 'No', value: false, disabled: false },
              ]}
            />

            <TextInput
              register={register}
              name={PURCHASE_START_TIME.key}
              label={PURCHASE_START_TIME.label}
              type="time"
              required
              hintText="GST time, 24h format (e.g. 09:00)"
              error={errors?.[PURCHASE_START_TIME.key]?.message as string}
            />

            <TextInput
              register={register}
              name={PURCHASE_END_TIME.key}
              label={PURCHASE_END_TIME.label}
              type="time"
              required
              hintText="GST time, must be after start time"
              error={errors?.[PURCHASE_END_TIME.key]?.message as string}
            />
          </div>

          <div className="my-4 flex gap-5">
            <Button buttonText="Create" className="w-32" />
            <Button
              buttonText="Cancel"
              variant="outline"
              type="button"
              onClick={backToPurchaseTimer}
              className="w-32"
            />
          </div>
        </form>
      </div>
    </div>
  )
}

export default PurchaseTimerAddForm
